import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import ChartContainerView from '@/data/views/chart_container';
import ChartModel from '@/data/models/chart';

export default Backbone.View.extend({
  //todo be more specific!
  el: "body",

  events: {
    "click a.showModal": "showModal",
  },

  initialize: function() {
    this.model = window.AFDC.active_chart;
    this.chart_container = new ChartContainerView({
      el: "#modal-chart-container",
      model: this.model,
    });
  },

  updateModel: function(id, callback) {
    id = parseInt(id, 10);
    // In most cases, the chart data will be pre-loaded on the collection
    // (since the Rails view sets all the data for the charts currently on the
    // page). However, for IE8-9 where the root page is always the first page
    // of un-filtered results (since it redirects to the hash-fragment URLs
    // like "/data/#10501"), we may also need to fetch the data via an ajax
    // request.
    this.model = window.AFDC.charts.get(id);
    if(this.model) {
      this.chart_container.update_model(this.model);
      callback();
    } else {
      var chart = new ChartModel({ id: id });
      chart.fetch({
        success: _.bind(function(model) {
          this.model = model;
          this.chart_container.update_model(this.model);
          callback();
        }, this)
      })
    }
  },

  showModal: function(e) {
    e.preventDefault();
    var id = $(e.currentTarget).data("chart");
		if (history.pushState) {
			window.app.history = window.location.pathname.replace(window.app.appRoot, "") + window.location.search;
		}

    window.app.navigateTo(id);
    document.title = "Alternative Fuels Data Center: Maps and Data - " + $(e.currentTarget).data("title");
  },
});
